module.exports = __webpack_public_path__ + "static/media/julesMapBaggage.4dd5478c.png";